<app-page-header [heading]="'HSN Report'" [icon]="'fa-calendar'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="row">
    <div class="form-group col-lg-4">
      <label>From</label>
      <input (ngModelChange)="fromdate = $event" [max]="getToday()" [ngModel]="fromdate | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">

    </div>
    <div class="form-group col-lg-4">
      <label>To</label>
      <input (ngModelChange)="todate = $event" [max]="getToday()" [ngModel]="todate | date:'yyyy-MM-dd'"
             class="form-control " id="todate" name="todate" type="date">
    </div>
    <div class="form-group col-lg-4">
      <label for="hsn_code">HSN Code</label>
      <input [(ngModel)]="hsncode" class="form-control " id="hsn_code" name="hsncode" type="text">
    </div>
    <div class="form-group col-lg-4">
      <label></label><br>
      <button (click)="listHsnReport();" class="btn btn-info btn-sm ng-star-inserted" type="button">&nbsp;Search&nbsp;
      </button>
    </div>
    <div class="clearfix"></div>
    <div class=" col-12">
      <table class="table tbl table-bordered" style="background-color: #f3f8fd">
        <thead>
        <tr class="text-center">
          <th class="text-center" width="5%">Sl</th>
          <th class="text-left" width="15%">HSN</th>
          <th class="text-left" width="10%">UOM</th>
          <th class="text-center" width="10%">Total Quantity</th>
          <th class="text-right" width="10%">Total Taxable Value</th>
          <th class="text-right" width="10%">VAT (%)</th>
          <th class="text-right" width="10%">VAT Total</th>
        </tr>
        <tr *ngIf="(stock_data | json) == '[]'">
          <td class="text-center" colspan="13">No data to list</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let stock of stock_data;let i=index">
          <td class="text-center">{{ i + 1 }}</td>
          <td class="text-left"> {{ stock.HSN_CODE }}</td>
          <td class="text-left"> {{ stock.SHORT_FORM }}</td>
          <td class="text-center"> {{ stock.SELLING_QUANTITY }}</td>
          <td class="text-right"> {{ stock.PRICE | number:'1.2-2'  }}</td>
          <td class="text-right"> {{ stock.VAT }}</td>
          <td class="text-right">{{ stock.SALE_VAT_AMOUNT | number:'1.2-2' }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
